export default __webpack_public_path__ + "static/media/next.eda251fe.svg";